import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod/v4";

const returnsCenterLocationSchema_ = z.object({
  id: z.string(),
  name: z.string(),
});
export const returnsCenterLocationSchema: z.ZodType<ReturnsCenterLocation> =
  returnsCenterLocationSchema_;
export interface ReturnsCenterLocation
  extends z.infer<typeof returnsCenterLocationSchema_> {}

export const getInventoryMetrics = unaryRpc({
  name: "getInventoryMetrics" as const,
  input: z.object({ returnsCenterId: z.string().optional() }),
  output: z.object({
    inventoryValueCents: z.number(),
    itemsOnHand: z.number(),
    refulfillmentRate: z.number().nullable(),
    returnsCenterLocations: z.array(returnsCenterLocationSchema),
    distinctGrades: z.array(z.string()),
    distinctDispositions: z.array(z.string()),
  }),
});

export type InventoryMetricsOutput = z.infer<
  (typeof getInventoryMetrics)["output"]
>;
